// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1aU39","fileBtn":"File_fileBtn__2NE1P","closeBtn":"File_closeBtn__2zqMH","fileSelected":"File_fileSelected__1f-uu","disabled":"File_disabled__2B-db"};